export interface Testimonial {
  name: string;
  city: string;
  quote: string;
  avatar?: string;
}

export interface Tomo {
  n: number;
  color: string;
  title: string;
  desc: string;
}

export interface Bono {
  n: number;
  title: string;
  desc: string;
  price: string;
  mockup: string;
}

export interface PricingOption {
  id: 'megapack' | 'elite';
  name: string;
  description: string;
  price: string;
  checkoutUrl: string;
  oldPrice?: string;
  savings?: string;
  featured?: boolean;
}

export const MINI_TESTIMONIALS: Testimonial[] = [
  {
    name: 'Marina T.',
    city: 'Rosario',
    quote: 'Dejé de improvisar los lunes. Tengo todo el mes armado.',
  },
  {
    name: 'Carla G.',
    city: 'Córdoba',
    quote: 'Mis clases se renovaron y los alumnos volvieron con todo.',
  },
  {
    name: 'Vicky R.',
    city: 'Mendoza',
    quote: 'Ahorro horas cada semana. Vale muchísimo la pena.',
  },
];

export const TOMOS: Tomo[] = [
  {
    n: 1,
    color: '#FF1E6C',
    title: 'Planificación Profesional de Clases',
    desc: 'Estructura completa, objetivos y tiempos: de la entrada en calor a la vuelta a la calma.',
  },
  {
    n: 2,
    color: '#C6E82E',
    title: 'Coreografías y Combinaciones de Pasos',
    desc: 'Secuencias y movimientos listos para todos los niveles.',
  },
  {
    n: 3,
    color: '#1FD1D9',
    title: 'Ritmos, Música y Selección de Canciones',
    desc: 'Cómo armar playlists equilibradas que mantienen la energía arriba.',
  },
  {
    n: 4,
    color: '#FFFFFF',
    title: 'Motivación y Manejo de Grupos',
    desc: 'Estrategias de conexión y comunicación con tus alumnos.',
  },
  {
    n: 5,
    color: '#B01254',
    title: 'Clases Temáticas y Eventos Especiales',
    desc: 'Desafíos, celebraciones y jornadas especiales para sorprender.',
  },
  {
    n: 6,
    color: '#D4F01A',
    title: 'Crecimiento Profesional para Instructores',
    desc: 'Imagen, promoción, organización de horarios y comunidad.',
  },
];

export const TOMO_INCLUDES: string[] = [
  'Contenido listo para aplicar en clase',
  'Ideas adaptables a distintos niveles',
  'Material 100% digital y descargable',
  'Actualizado y pensado para instructores reales',
];

export const BONOS: Bono[] = [
  {
    n: 1,
    title: 'Zumba Kids — Clases Listas para Niños y Niñas',
    desc: 'Propuestas divertidas, juegos y dinámicas para dar clases infantiles con confianza.',
    price: '$6.990',
    mockup: 'https://cdn.magicpatterns.com/uploads/2iPkiEHeebMjnhdNzZY9qf/BONO_1.png',
  },
  {
    n: 2,
    title: 'Calendario Anual de Clases Temáticas',
    desc: 'Un año entero de ideas para planificar fechas especiales, estaciones y celebraciones.',
    price: '$5.990',
    mockup: 'https://cdn.magicpatterns.com/uploads/qho37YYnffV2RHqKyUM8eu/BONO_2.png',
  },
  {
    n: 3,
    title: 'Planner Imprimible de Clases Mensuales',
    desc: 'Calendario, plan de clase y checklist listos para imprimir y organizar cada mes.',
    price: '$4.990',
    mockup: 'https://cdn.magicpatterns.com/uploads/aUGZiqioy98h2Ymotv6fxP/BONO_3.png',
  },
  {
    n: 4,
    title: 'Guiones de WhatsApp para Vender Clases',
    desc: 'Mensajes probados para responder consultas, convertir interesadas y sumar alumnas.',
    price: '$7.990',
    mockup: 'https://cdn.magicpatterns.com/uploads/i8Z5NQkfg44DggovYHNg2D/BONO_4.png',
  },
  {
    n: 5,
    title: '30 Ideas de Reels para Profes de Zumba',
    desc: 'Ideas listas para crear contenido, ganar visibilidad y atraer más alumnos.',
    price: '$6.990',
    mockup: 'https://cdn.magicpatterns.com/uploads/ih3NogU3reBzF89YbHFmCw/BONO_5.png',
  },
];

export const PAIN_POINTS: string[] = [
  'Domingo a la noche buscando canciones nuevas para el lunes.',
  'Las mismas coreografías de siempre porque no tenés tiempo de crear otras.',
  'Alumnos que se aburren y dejan de venir por falta de variedad.',
  'Grupos de distintos niveles juntos, sin material adaptado.',
  'Improvisar la clase minutos antes de que llegue la gente.',
  'Fin de semana laburando en vez de descansar.',
];

export const COMPARISON: { without: string; with: string }[] = [
  {
    without: 'Horas perdidas buscando música y coreografías',
    with: 'Playlists y secuencias listas en minutos',
  },
  {
    without: 'Clases repetitivas que aburren',
    with: 'Clases variadas y temáticas todo el año',
  },
  {
    without: 'Alumnos que dejan de venir',
    with: 'Alumnos motivados que traen amigos',
  },
  {
    without: 'Fines de semana trabajando',
    with: 'Descansás con todo ya planificado',
  },
  {
    without: 'Improvisar sin estructura',
    with: 'Un sistema profesional probado',
  },
];

export const FULL_TESTIMONIALS: Testimonial[] = [
  {
    name: 'Marina T.',
    city: 'Rosario',
    quote:
      'Antes armaba las clases a último momento y siempre estresada. Con el Megapack tengo el mes entero listo y mis clases se llenaron de nuevo.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/041a5060-1cfa-411d-9513-4cf7a0573baa.jpg',
  },
  {
    name: 'Carla G.',
    city: 'Córdoba',
    quote:
      'Los tomos de coreografías y ritmos me salvaron. Renové todo mi repertorio en una semana y los alumnos lo notaron enseguida.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/45608e29-89c7-4c89-884b-160e42c02b91.jpg',
  },
  {
    name: 'Vicky R.',
    city: 'Mendoza',
    quote:
      'Lo que más valoro es el tiempo. Recuperé mis domingos y mis clases son más profesionales que nunca.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/670ddda8-d9e5-4a5a-b95e-fd2550a59b05.jpg',
  },
  {
    name: 'Sofía M.',
    city: 'La Plata',
    quote:
      'El bono de promoción me ayudó a llenar mis horarios. Pasé de 2 grupos a 5 en tres meses. Recomendadísimo.',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/1abd6a07-f650-43c3-9af6-cedac909dfc7.jpg',
  },
];

export const FAQS: { q: string; a: string }[] = [
  {
    q: '¿Sirve para todos los niveles?',
    a: 'Sí. El material está pensado para adaptarse a grupos principiantes, intermedios y avanzados. Cada tomo incluye ideas para ajustar la intensidad y la dificultad según tu clase.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Es 100% digital. Apenas confirmás el pago recibís por email el acceso a todos los tomos y bonos en formato PDF descargable, listos para usar en cualquier dispositivo.',
  },
  {
    q: '¿Necesito experiencia previa dando clases?',
    a: 'No es necesaria. El Megapack te da estructura desde cero, pero también es ideal si ya das clases y querés profesionalizar y ahorrar tiempo en tu planificación.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días de garantía sin preguntas. Si el material no es lo que esperabas, te devolvemos el 100% de tu dinero, sin formularios ni complicaciones.',
  },
];

export const PRICING_OPTIONS: PricingOption[] = [
  {
    id: 'megapack',
    name: 'Megapack Zumba Pro',
    description: '6 Tomos + 5 Bonos',
    price: '$19.900',
    checkoutUrl: 'https://aulabailepro.store/cart/45601468088390:1',
  },
  {
    id: 'elite',
    name: 'Megapack + Zumba Pro Elite',
    description: '6 Tomos + 5 Bonos + Kit Elite (50–60 págs. de contenido avanzado)',
    oldPrice: '$47.980',
    price: '$27.990',
    checkoutUrl: 'https://aulabailepro.store/cart/45601468547142:1',
    savings: 'Ahorrás $19.990',
    featured: true,
  },
];

export const ELITE_COMPARISON = [
  { situation: 'Duración de clase', megapack: 'Estructura general', elite: 'Planificación de 45, 50 y 60 min' },
  { situation: 'Coreografías', megapack: 'Ideas de pasos y combinaciones', elite: 'Métodos simples y efectivos para crear coreografías' },
  { situation: 'Selección de música', megapack: 'Playlists equilibradas', elite: 'Canciones según nivel de energía' },
  { situation: 'Transiciones', megapack: 'A criterio del profesor', elite: 'Transiciones profesionales entre canciones' },
  { situation: 'Niveles', megapack: 'Adaptable', elite: 'Adaptación específica por nivel' },
  { situation: 'Variedad', megapack: 'Buena', elite: 'Estrategias para evitar clases repetitivas' },
];

export const ELITE_INCLUDES = [
  'Planificación de clases de 45 minutos',
  'Planificación de clases de 50 minutos',
  'Planificación de clases de 60 minutos',
  'Métodos para crear coreografías simples y efectivas',
  'Selección de canciones según el nivel de energía',
  'Adaptación de clases para distintos niveles',
  'Transiciones profesionales entre canciones',
  'Estrategias para evitar clases repetitivas',
  'Técnicas para mejorar la experiencia de los alumnos',
];

export const PRICING = {
  currency: 'ARS',
  bonusValueOld: '$31.950',
};
